import React from "react";
import { Link } from "react-router-dom";

const OverCreditBanner = ({
  message,
  linkTo,
  linkText,
}: {
  message?: string;
  linkTo: string;
  linkText: string;
}) => (
  <div className="w-full bg-warning text-white text-sm font-semibold px-4 py-2 flex items-center justify-center gap-1">
    <svg
      viewBox="0 0 20 20"
      fill="white"
      aria-hidden="true"
      className="size-5 shrink-0"
    >
      <path
        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
    {message && <span>{message} </span>}
    <Link to={linkTo} className="underline hover:opacity-80">
      {linkText}
    </Link>
  </div>
);

export default OverCreditBanner;
